export default __webpack_public_path__ + "static/media/connect_prac.b770b704.svg";